(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/banner_layouts/rectangular-image/assets/javascripts/render-component.js') >= 0) return;  svs.modules.push('/components/banner_layouts/rectangular-image/assets/javascripts/render-component.js');

'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const layoutType = 'rectangular_image';
const isServer = typeof exports === 'object';
const _ref = isServer && require('@svenskaspelab/trinidad-core') || {},
  core = _ref.core;
const bannerHelpers = isServer ? core.components.require('banner_common', 'banner-helpers') : svs.banner_common.banner_helpers;
const getRCTools = bannerHelpers.getRCTools,
  groupNumbers = bannerHelpers.groupNumbers;

const renderComponent = async (model, widget, position, req, res) => {
  const callToActions = model.callToActions,
    id = model.id,
    images = model.images,
    layoutConfig = model.layoutConfig,
    targetOffer = model.targetOffer;
  const tracking = {
    widget,
    position
  };
  const _getRCTools = getRCTools({
      layoutType,
      model,
      res,
      req,
      tracking
    }),
    contentType = _getRCTools.contentType,
    features = _getRCTools.features,
    hbsCompiled = _getRCTools.hbsCompiled,
    isAdmin = _getRCTools.isAdmin,
    trackingString = _getRCTools.trackingString;
  const hasBgImage = images && Boolean(images[0]);
  const image = hasBgImage && _objectSpread(_objectSpread({}, images[0]), {}, {
    aspectRatio: {
      width: '100%',
      height: '110'
    }
  });
  const action = callToActions[0].actionConfig;
  const bannerHeight = 110;
  const heading = groupNumbers(layoutConfig.heading);
  const placeholderHeading = 'Exempelrubrik';
  const hasProductOrLinkText = Boolean(layoutConfig.product || layoutConfig.linkText);
  const context = _objectSpread(_objectSpread({}, layoutConfig), {}, {
    action,
    features,
    id,
    bannerHeight,
    hasBgImage,
    image,
    contentType,
    targetOffer,
    hasProductOrLinkText,
    heading,
    isAdmin,
    placeholderHeading,
    trackingString
  });
  return hbsCompiled(context);
};
if (isServer) {
  module.exports = {
    renderComponent
  };
} else {
  svs.banner_layouts.rectangular_image = {
    renderComponent
  };
}

 })(window);